import React, { useEffect, useState } from 'react';

import { setBreadcrumbs } from '../../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';
import EmployeeSessionView from './EmployeeSessionView';

const EmployeeView = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isLocked, setIsLocked] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('empId');
  const tab = searchParams.get("tab");
  const sessionId = searchParams.get("sessionId");
  const sessionView = searchParams.get('sessionView');
console.log(employeeId ,"employeeIdemployeeId")
  const storedEmployeeName = useSelector((state) => state.employeeView?.employeeName);
  const storedSessionName = useSelector((state) => state.sessionView?.sessionName);
 
  // ✅ Breadcrumbs
  useEffect(() => {
    const crumbs = [
      { label: "Employees", url: "/employee", home: "/companies" },
      { label: storedEmployeeName || "Employee View", url: `/employee/view?empId=${employeeId}&tab=${tab}` },
    ];

    if (sessionView) {
      crumbs.push({
        label: storedSessionName || "Session View",
        url: `/employee/view?sessionId=${sessionId}&tab=${tab}&empId=${employeeId}&sessionView=${sessionView}`,
      });
    }

    dispatch(setBreadcrumbs(crumbs));
  }, [sessionId, tab, employeeId, sessionView, dispatch, storedEmployeeName, storedSessionName]);

  // ✅ Keep tab synced
  useEffect(() => {
    if (sessionView === "view") {
      setActiveTab('sessions');
    }
  }, [sessionView]);

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">
        
          <EmployeeSessionView />

        </div>
      </div>
    </div>
  );
};

export default EmployeeView;
